export default {
  cleanFilters: 'Limpiar filtros',
  titleButton: 'Filtros',
  filtersTitle: 'Filtros',
  cleanFilter: 'Limpiar filtros',
  apply: 'Aplicar',
  stateFilterLabel: 'Estado',
  dateFilter: 'Fechas',
  dateFieldLabel: 'Rango de fechas'
}
